import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { lojaService } from "../services/lojaService";
import { LojaFilters } from "../types/loja";
import { LojaFormData } from "../lib/validations";
import { useGlobalStore } from "../store/globalStore";
import { getErrorMessage } from "../utils/errorHandler";

export const useLojas = (filters?: LojaFilters) => {
  return useQuery({
    queryKey: ["lojas", filters],
    queryFn: () => lojaService.getLojas(filters),
  });
};

export const useLojaById = (id: number | undefined) => {
  return useQuery({
    queryKey: ["loja", id],
    queryFn: () => lojaService.getLojaById(id!),
    enabled: !!id,
  });
};

export const useCreateLoja = () => {
  const queryClient = useQueryClient();
  const { setError } = useGlobalStore();

  return useMutation({
    mutationFn: (data: LojaFormData) => lojaService.createLoja(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["lojas"] });
    },
    onError: (error) => setError(getErrorMessage(error)),
  });
};

export const useUpdateLoja = () => {
  const queryClient = useQueryClient();
  const { setError } = useGlobalStore();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: LojaFormData }) =>
      lojaService.updateLoja(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["lojas"] });
    },
    onError: (error) => setError(getErrorMessage(error)),
  });
};

export const useDeleteLoja = () => {
  const queryClient = useQueryClient();
  const { setError } = useGlobalStore();

  return useMutation({
    mutationFn: (id: number) => lojaService.deleteLoja(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["lojas"] });
    },
    onError: (error) => setError(getErrorMessage(error)),
  });
};
